<script>
	let currentDate = new Date(); // Get the current date
	let currentMonth = currentDate.getMonth(); // Get the current month (0-11)
	let currentYear = currentDate.getFullYear(); // Get the current year

	let months = [
		'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September',
		'October', 'November', 'December'
	];

	// Function to navigate to the previous month
	function previousMonth()
	{
		if (currentMonth === 0)
		{
			currentYear--;
			currentMonth = 11;
		}
		else
		{
			currentMonth--;
		}
	}

	// Function to navigate to the next month
	function nextMonth()
	{
		if (currentMonth === 11)
		{
			currentYear++;
			currentMonth = 0;
		}
		else
		{
			currentMonth++;
		}
	}

	// Function to get the total number of days in a month
	function getDaysInMonth(month, year)
	{
		return new Date(year, month + 1, 0).getDate();
	}


	function getSlots()
	{
		selectedDate = null;
		selectedSlot = null;
		arr = [];

		fetch(bookingConfig.url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
			body: new URLSearchParams({
				action: 'booking_get_slots',
				year: currentYear,
				month: currentMonth+1
			}),
		}).then(x => x.json()).then(x => {
			if (x)
			{
				arr = x;
			}
			else
			{
				arr = [];
			}
		})
	}

	$: {
		getSlots(currentYear, currentMonth);
	}

	export let selected = null;

	let selectedDate;
	let selectedSlot;
	let arr = [];

	$: if (selectedSlot)
	{
		selected = {
			month: currentMonth+1,
			year: currentYear,
			date: selectedDate.date,
			slot: selectedSlot
		};
	}
	else
	{
		selected = null;
	}

</script>

<h2 class="text-xl lg:text-3xl font-semibold uppercase tracking-wide lg:leading-tight">
	Select Date & Time
</h2>

<!-- <p class="text-lg text-center">Select Date & Time of The event</p> -->

<div class="flex flex-col lg:flex-row gap-2 w-full max-w-[800px] justify-center">
	<div class="flex flex-col gap-4 bg-white p-6 border">
		<div class="flex gap-3 justify-center items-center text-dark text-sm">
			<svg on:click={previousMonth} class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
			</svg>
			{months[currentMonth]} {currentYear}
			<svg on:click={nextMonth} class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
				<path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
			</svg>
		</div>
		<div class="grid grid-cols-7 gap-2">
			<span class="w-10 h-10 flex items-center justify-center">Sun</span>
			<span class="w-10 h-10 flex items-center justify-center">Mon</span>
			<span class="w-10 h-10 flex items-center justify-center">Tue</span>
			<span class="w-10 h-10 flex items-center justify-center">Wed</span>
			<span class="w-10 h-10 flex items-center justify-center">Thu</span>
			<span class="w-10 h-10 flex items-center justify-center">Fri</span>
			<span class="w-10 h-10 flex items-center justify-center">Sat</span>
			<div class="col-span-7 h-px bg-dark bg-opacity-10 mb-2"></div>
			{#each arr as item}
				{#if item.slots.length == 0}
				<span class="text-dark text-opacity-30 w-10 h-10 flex items-center justify-center border border-dark border-opacity-5 bg-light">{item.date}</span>
				{:else if selectedDate==item}
				<span class="w-10 h-10 flex items-center justify-center border border-transparent bg-primary text-white">{item.date}</span>
				{:else}
				<span on:click={()=>{selectedSlot=null; selectedDate=item;}} class="text-dark w-10 h-10 flex items-center justify-center border border-[#e0d7d7] bg-light border-b-4 border-b-primary !border-b-opacity-100">{item.date}</span>
				{/if}


<!-- 				{#if idx == 15}
				<span class="w-10 h-10 flex items-center justify-center border border-transparent bg-primary text-white">{idx + 1}</span>
				{:else if idx == 10 || idx == 16}
				<span class="text-dark w-10 h-10 flex items-center justify-center border border-[#e0d7d7] bg-light border-b-4 border-b-primary !border-b-opacity-100">{idx + 1}</span>
				{:else}
				<span class="text-dark text-opacity-30 w-10 h-10 flex items-center justify-center border border-dark border-opacity-5 bg-light">{idx + 1}</span>
				{/if}
			-->
			{/each}
		</div>
	</div>
	<div class="flex flex-col gap-4 bg-white p-6 border w-full max-w-[300px] items-center">
		<span class="text-sm">Time</span>
		<div class="flex flex-col gap-2 w-full">
			{#if selectedDate}
				<span class="h-10 flex items-center justify-center text-primary">{currentMonth} / {selectedDate.date} / {currentYear}</span>
				<div class="col-span-7 h-px bg-dark bg-opacity-10 mb-2 w-full"></div>
				{#each selectedDate.slots as slot}
					<div on:click="{()=>selectedSlot=slot}" class="w-full text-center text-sm lg:text-base whitespace-nowrap bg-light border border-dark border-opacity-5 p-2 {selectedSlot==slot?'bg-primary text-white':''}">{slot[0][0]} <span class="text-xs">{slot[0][1]}</span> <span class="px-1">-</span> {slot[1][0]} <span class="text-xs">{slot[1][1]}</span></div>
				{/each}
			{/if}
		</div>
	</div>
</div>

<div class="text-lg text-center flex flex-col gap-2 lg:px-10">
	<span class="text-red-500 text-xl font-semibold">Booking Fee</span>
	<p>Booking fee of $150 will be charged at checkout which includes:</p>
	<p>Set-up, Tables, Sauces (Ginger, Ginger Salad, Yum Yum), Table Clothes (for set-up), Napkins, Forks, Chopsticks, Plates, Spoons, burners and chaffing trays.</p>
	<p class="mt-2 italic">We Travel up to 1 hour from St. Charles</p>
</div>

